import { useState } from 'react';

import { HelpModal } from './HelpModal';
import styles from './TelephoneNavItem.module.css';
import { ReactComponent as TelephoneIcon } from '../../../svg/TelephoneIcon.svg';

export const TelephoneNavItem = () => {
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  return (
    <>
      <button
        className={styles.navBarAnchor}
        onClick={() => setIsHelpModalOpen(true)}
      >
        Help
        <TelephoneIcon className={styles.telephoneIcon} />
      </button>
      <HelpModal
        isOpen={isHelpModalOpen}
        closeModal={() => setIsHelpModalOpen(false)}
      />
    </>
  );
};
